// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Specifies the user account type.
 * @export
 * @enum {string}
 */
export enum RESTBackupUserAccountType {
    User = 'User',
    SharedMailbox = 'SharedMailbox',
    PublicMailbox = 'PublicMailbox'
}

